import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface HomeSidebarProps {
  ranking: Movie[];
}

const quickLinks = [
  { label: "电影", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧", to: "/category/tv", icon: "ri-tv-2-line" },
  { label: "最新资讯", to: "/news", icon: "ri-newspaper-line" },
  { label: "悬疑推理", to: "/search?q=悬疑", icon: "ri-search-eye-line" },
  { label: "古装权谋", to: "/search?q=古装", icon: "ri-ancient-gate-line" },
  { label: "硬核科幻", to: "/search?q=科幻", icon: "ri-rocket-2-line" },
];

export default function HomeSidebar({ ranking }: HomeSidebarProps) {
  return (
    <div className="flex h-full flex-col gap-4">
      <div className="rounded-xl border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
          <i className="ri-apps-2-line text-accent-600" /> 快捷分类
        </h3>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {quickLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="flex cursor-pointer flex-col items-center gap-1.5 rounded-lg border border-background-200 bg-background-100 px-1 py-3 text-center transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <i className={`${link.icon} text-lg text-primary-600`} />
              <span className="whitespace-nowrap text-xs text-foreground-700">{link.label}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="flex-1 rounded-xl border border-background-200 bg-background-50 p-4">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
            <i className="ri-bar-chart-fill text-accent-600" /> 热播榜
          </h3>
          <Link to="/category/movie" className="text-xs text-foreground-500 transition-colors hover:text-accent-600">
            更多
          </Link>
        </div>
        <ul className="mt-3 space-y-1">
          {ranking.map((movie, i) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="flex cursor-pointer items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-background-100"
              >
                <span
                  className={`w-5 shrink-0 text-center font-heading text-sm font-bold ${
                    i < 3 ? "text-accent-600" : "text-foreground-400"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="flex-1 truncate text-sm text-foreground-800">{movie.title}</span>
                <span className="shrink-0 text-xs font-semibold text-foreground-500">
                  {movie.popularity > 9999 ? "9.9k" : `${(movie.popularity / 1000).toFixed(1)}k`}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}